// Single source of truth for route paths. Use these instead of hardcoded
// strings so renames propagate automatically.

export const paths = {
  login: '/login',
  dashboard: '/',
  users: '/users',
  userDetail: (id: string) => `/users/${id}`,
  companies: '/companies',
  companyDetail: (id: string) => `/companies/${id}`,
  countries: '/countries',
  countryDetail: (code: string) => `/countries/${code}`,
  safetyScores: '/safety-scores',
  safetyScoreDetail: (code: string) => `/safety-scores/${code}`,
  weights: '/weights',
  simulation: '/simulation',
  newsSources: '/news-sources',
  newsSourceNew: '/news-sources/new',
  kimi: '/kimi',
  plans: '/plans',
  planNew: '/plans/new',
  planEdit: (code: string) => `/plans/${code}/edit`,
  config: '/config',
  featureToggles: '/feature-toggles',
  bookingsAudit: '/bookings-audit',
  bookingDetail: (id: string) => `/bookings-audit/${id}`,
  paymentsAudit: '/payments-audit',
  paymentDetail: (id: string) => `/payments-audit/${id}`,
  support: '/support',
  supportTicket: (id: string) => `/support/${id}`,
  pushBroadcasts: '/push-broadcasts',
  auditLog: '/audit-log',
  system: '/system',
  notFound: '/404',
} as const;
